import type { Variant } from './variants';
import type { HistoryProps } from './type';

type HistoryDefaults = Required<Pick<HistoryProps, 'title' | 'items'>>;

export const defaultContent: Record<Variant, HistoryDefaults> = {
  slide: {
    title: "Where it began — <i>Nick's story</i>",
    items: [
      {
        title: 'Standing up for change',
        description:
          "Nick pursued a career in law driven by a personal experience that shaped his belief that people deserve honest guidance and strong advocacy during life's hardest moments.",
        image: '/images/nick-story-main-v2.webp',
      },
      {
        title: 'A lifelong commitment',
        description:
          'Nick earned his undergraduate degree from Duke University and his law degree from the University of Houston Law Center. In 1996, he founded Johnson Law Group with a mission to help individuals affected by injuries or illness caused by negligence.',
        image: '/images/nick-story-commitment.webp',
      },
      {
        title: 'Making a difference',
        description:
          'Nick has worked on several landmark cases, securing critical outcomes for clients affected by negligence, dangerous products, and corporate wrongdoing.',
        image: '/images/nick-story-main-v2.webp',
      },
      {
        title: 'Shaping the future',
        description:
          'Nick is actively involved in organizations that work to elevate legal advocacy and improve standards across the industry. He is a member of several legal associations and has been recognized as a member of The National Trial Lawyers Top 100.',
        image: '/images/nick-story-main-v2.webp',
        badges: [
          '/images/badge-aba.webp',
          '/images/badge-texas-lawyers.webp',
          '/images/badge-hba.webp',
          '/images/national-top-100-trial-lawyers.webp',
        ],
      },
      {
        title: 'In the community',
        description:
          'Nick is passionate about expanding educational opportunities for students and proudly supports Emerge Scholars, which helps high-achieving students from low-income communities attend top colleges and universities.',
        image: '/images/nick-story-main-v2.webp',
      },
    ],
  },
  vertical: {
    title: 'History of <i>our firm</i>',
    items: [
      {
        title: 'Founded in 1996',
        description:
          "Johnson Law Group was founded with a simple mission: help people navigate some of life's most difficult moments with genuine care and fierce advocacy.",
        image: '/images/history-founded-1996.webp',
      },
      {
        title: 'Houston HQ',
        description:
          'Built in Houston, serving clients nationwide. While our roots remain in Houston, our reach extends across the country through offices and teams dedicated to serving clients where they need us most.',
        image: '/images/history-houston-hq.webp',
      },
      {
        title: 'International reach',
        description:
          'Today, Johnson Law Group operates across the United States and the United Kingdom, advocating for thousands of individuals injured by car accidents, slip and falls, negligence, dangerous products, and beyond. See our <a href="https://johnsonlawgroup.com/practice-areas" target="_self"><b>Practice Areas</b></a> page for more.',
        image: '/images/history-international-reach.webp',
      },
    ],
  },
};
